// account.js — Einträge des Konto-Menüs (rein). Die Bereiche kommen fertig vom Server (/api/me → areas, lib/areas.js).
import { t } from './i18n.js';

/** Verwaltung öffnet in einem eigenen Tab (Arbeitsbereich neben der App, seit v395). */
export const newTab = (a) => a && a.id === 'admin';

/** Menü-Einträge für openMenu(): Kopf (Name), Bereiche, Profil, Abmelden. current = id des Bereichs, in dem man gerade ist. */
export function accountItems(me, { current, profileUrl }) {
  const head = (me && (me.name || me.email)) || '';
  const areas = (me && Array.isArray(me.areas) ? me.areas : []).map((a) => ({
    value: a.url, label: t('ui.area_' + a.key), icon: a.icon, current: a.id === current, newTab: newTab(a) && a.id !== current,
  }));
  return [
    ...(head ? [{ group: head }] : []),
    ...areas,
    { divider: true },
    { value: profileUrl, label: t('ui.acct_profile'), icon: 'manage_accounts' },
    { value: '/auth/logout', label: t('ui.acct_logout'), icon: 'logout' },
  ];
}

/** Ein bis zwei Buchstaben für den Avatar ohne Bild. */
export function initials(me) {
  const src = String((me && (me.name || me.email)) || '').trim();
  if (!src) return '?';
  const words = (me.name ? src.split(/\s+/) : [src]).filter(Boolean);
  return words.slice(0, 2).map((w) => w[0]).join('').toUpperCase();
}
